import { render, staticRenderFns } from "./BB-text.vue?vue&type=template&id=22a19a2a&"
import script from "./BB-text.vue?vue&type=script&lang=js&"
export * from "./BB-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports